import { useTheme } from "@mui/material"
import { Palette } from "@mui/material/styles"
import { useEffect, useRef } from "react"

type GetChangeColorOptions =
  | {
      previous: number | undefined
      current: number
    }
  | {
      change: number
    }

const getChangeColor = (
  options: GetChangeColorOptions,
): keyof Palette | undefined => {
  let change: number
  if ("current" in options) {
    if (options.previous == null) {
      return
    }
    change = options.current - options.previous
  } else {
    change = options.change
  }
  if (change >= 0) {
    return "positive"
  }

  return "negative"
}

export const getChangeTextColor = (
  options: GetChangeColorOptions,
): keyof Palette | undefined => {
  const color = getChangeColor(options)

  return color ? color : undefined
}

export type UseChangeColorOptions = {
  fallback: keyof Palette
  current: number | undefined
}

export const useChangePaletteColor = ({
  fallback,
  current,
}: UseChangeColorOptions) => {
  const theme = useTheme()
  const previousPrice = useRef<number>()

  useEffect(() => {
    previousPrice.current = current
  })

  const color = getChangeColor({
    current: current ?? 0,
    previous: previousPrice.current,
  })

  return theme.palette[color ?? fallback] as string
}
